import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'uz',
    fullName: 'Uzbek',
    nativeName: 'O‘zbek',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Ajoyib bir narsa keladi",
    landing_subtitle: "ArgVoid - bu ilovalar va o'yinlarni ishlab chiqish studiyasi. Kuzatib qoling, tez orada yangi narsalar keladi!",
    select_language: "Tilni tanlang",
    search_placeholder: "Tillarni qidirish...",
    terms_title: "Xizmat shartlari",
    policy_title: "Maxfiylik siyosati",
    cookies_title: "Cookie siyosati",
    terms_content: `
        <strong>1. </strong><br> shartlarini qabul qilish
        ArgVoid-ga kirish orqali ushbu Xizmat shartlari qabul qilinadi. Agar bu shartlar rozi bo'lmasa, xizmatdan foydalanmaslik kerak.<br><br>

        <strong>2. Platformadan foydalanish</strong><br>
        ArgVoid va uning ilovalari axborot va ijodiy maqsadlar uchun "xuddi shunday" taqdim etiladi. Xizmatdan faqat qonuniy maqsadlarda foydalanish kerak.<br><br>

        <strong>3. Taqiqlangan xatti-harakatlar</strong><br>
        Sayt zaifliklaridan foydalanish, spam yuborish yoki infratuzilmaga ruxsatsiz kirishga urinish qat'iyan man etiladi.<br><br>

        <strong>4. Rad etish </strong><br>
        Platforma va xizmatlar istalgan vaqtda ogohlantirmasdan o'zgartirilishi mumkin. Xizmatning ish vaqti yoki mavjudligi haqida hech qanday kafolat berilmaydi.
    `,
    policy_content: `
        <strong>1. Ma'lumotlar to'plami</strong><br>
        Ayni paytda platforma foydalanuvchi autentifikatsiyasini yoki hisob yaratishni talab qilmaydi. Mehmonlardan shaxsiy identifikatsiya qiluvchi ma'lumotlar (masalan, ismlar yoki elektron pochta manzillari) faol ravishda to'planmaydi.<br><br>

        <strong>2. Foydalanish Data</strong><br>
        Sayt trafigini tushunish va ilovalarni yaxshilash uchun asosiy, anonim tahlillar to'planishi mumkin. Bu maʼlumotlar individual foydalanuvchi identifikatorlari bilan bogʻlanmagan.<br><br>

        <strong>3. Uchinchi tomon xizmatlari</strong><br>
        Xosting va tahlil xizmatlari uchun uchinchi tomon provayderlaridan foydalanish mumkin. Ushbu tegishli provayderlarning maxfiylik amaliyotlari ularning infratuzilmasida qayta ishlangan anonim maʼlumotlarni boshqaradi.<br><br>

        <strong>4. Ma'lumotlar xavfsizligi</strong><br>
        Platformani himoya qilish uchun oqilona xavfsizlik choralari qo'llaniladi. Biroq, Internet orqali uzatishning hech qanday usuli butunlay xavfsiz emas.<br><br>
    `,
    cookies_content: `
        <strong>1. Cookie fayllari va mahalliy saqlash nima? </strong><br>
        Cookie-fayllar va brauzerning mahalliy xotirasi tashriflar davomida konfiguratsiya sozlamalarini eslab qolish uchun qurilmada saqlanadigan kichik maʼlumotlar fayllaridir.<br><br>

        <strong>2. Foydalanish maqsadi</strong><br>
        Brauzer LocalStorage qat'iy ravishda konfiguratsiya sozlamalarini saqlash uchun ishlatiladi, masalan: <br>
        - Til sozlamalari<br>
        - Foydalanuvchi interfeysi konfiguratsiyasi (masalan, tartib yoki mavzu sozlamalari) <br>
        - Vaqtinchalik dastur keshi<br><br>

        <strong>3. Kuzatuv yo'q</strong><br>
        Cookie fayllari va mahalliy xotira reklama yoki uchinchi tomon kuzatuvi uchun ishlatilmaydi. Barcha saqlangan ma'lumotlar platformaning asosiy funksionalligi uchundir.<br><br>

        <strong>4. Control</strong><br>
        Brauzer ma'lumotlari istalgan vaqtda brauzer sozlamalari orqali tozalanishi mumkin, bu esa har qanday mahalliy konfiguratsiyalarni tiklaydi.
    `,
    cookie_consent_text: "Biz veb-sayt funksiyalarini to‘g‘ri ishlashini ta’minlash uchun asosiy cookie-fayllardan foydalanamiz, masalan, seansni faol ushlab turish, til sozlamalarini saqlash va boshqa maxsus konfiguratsiyalar.",
    read_policy: "Cookie siyosatini o'qing",
    support_title: "Qo‘llab-quvvatlash xizmatiga murojaat qiling",
    support_subject_label: "Mavzu",
    support_message_label: "Xabar",
    support_submit_button: "Xabar yuborish",
    support_hint: "Eslatma: Bu xabarni yuborish uchun standart elektron pochta ilovangizni ochadi.",
    support_success_msg: "Email ilovangiz ochilmoqda...",
    support_error_msg: "Xabar yuborilmadi. Keyinroq qayta urinib ko‘ring.",
    explorer_title: "Explorer",
    history_title: "Tarix",
    animation_title: "Animatsiya",
    config_title: "Konfiguratsiya",
    tool_mouse: "Tanlang (Ctrl+M)",
    tool_brush: "Cho‘tkasi (Ctrl+B)",
    tool_brush_mode: "Oʻchirish rejimi (qattiq/toza)",
    tool_eraser: "Oʻchirgich (Ctrl+E)",
    tool_brush_size: "Brush hajmini sozlang",
    tool_bucket: "Toʻldirish (Ctrl+F)",
    tool_eyedropper: "Ko'z tomchisi",
    tool_grid: "To‘r (Ctrl+Shift+B)",
    tool_rotate: "Aylantirish (Ctrl+Shift+R)",
    tool_flip_h: "H aylantiring (Ctrl+Shift+H)",
    tool_flip_v: "Flip V (Ctrl+Shift+V)",
    tool_transpose: "Transpozitsiya (Ctrl+Shift+T)",
    label_width: "Kengligi",
    label_height: "Balandligi",
    label_frames: "Ramkalar soni",
    label_animation: "Animatsiya uslubi",
    label_background_color: "Fon rangi",
    label_interval: "Interval",
    tool_anim_config: "Animatsiya konfiguratsiyasi",
    label_new_width: "Yangi kenglik",
    label_new_height: "Yangi balandlik",
    label_apply: "Murojaat qiling",
    label_colors: "Ranglar",
    label_size: "Hajmi",
    label_tolerance: "Tolerantlik",
    val_horizontal: "Gorizontal",
    val_vertical: "Vertikal",
    val_sequence: "Ketma-ketlik",
    val_bounce: "Bounce",
    val_random: "Tasodifiy",
    val_solid: "Qattiq",
    val_clear: "Tozalash",
    action_add_sheet: "Yangi varaq",
    action_import: "Import",
    action_export: "Eksport",
    action_sort_projects: "Saralash",
    sort_date_old: "Eng qadimgi Birinchi",
    sort_date_new: "Eng yangi birinchi",
    sort_name_az: "Ism (Az-Z)",
    sort_name_za: "Ism (Z-A)",
    action_new_sprite: "Yangi Sprite",
    action_new_project: "Yangi Loyiha",
    modal_save_all_title: "Barcha o'zgarishlarni saqlang",
    modal_save_all_desc: "Saqlash uchun aktivlarni tanlang:",
    modal_save_selected: "Tanlanganni saqlash",
    action_saved: "Saqlangan",
    modal_create_sprite_title: "Yangi Sprite yarating",
    modal_create_project_title: "Yangi loyiha yaratish",
    modal_add_sheet_title: "Yangi varaq qo'shish",
    modal_rename_sheet_title: "Varaq nomini o'zgartirish",
    modal_rename_sprite_title: "Sprite nomini o'zgartiring",
    modal_delete_sprite_title: "Sprite-ni o'chirish",
    modal_delete_project_title: "Loyihani o'chirish",
    modal_delete_sheet_title: "Jadvalni o'chirish",
    placeholder_sprite_name: "Ism",
    placeholder_project_name: "Ism",
    placeholder_sheet_name: "Ism",
    placeholder_new_name: "Yangi ism",
    action_create: "Yaratish",
    action_add: "Qo'shish",
    action_rename: "Nomini o'zgartirish",
    action_duplicate: "Dublikat",
    action_delete: "Oʻchirish",
    action_cancel: "Bekor qilish",
    confirm_delete_sprite: "Haqiqatan ham bu spritni oʻchirib tashlamoqchimisiz?",
    confirm_delete_project: "Haqiqatan ham bu loyihani oʻchirib tashlamoqchimisiz? Barcha spritlar o'chiriladi.",
    confirm_delete_sheet: "Haqiqatan ham bu varaqni oʻchirib tashlamoqchimisiz?",
    err_select_sprite: "Iltimos, avval spritni tanlang.",
    err_select_project: "Iltimos, avval loyihani tanlang.",
    err_name_empty: "Ism bo'sh bo'lishi mumkin emas.",
    err_sprite_exists: "Bunday nomli sprayt allaqachon mavjud.",
    err_project_exists: "Bunday nomdagi loyiha allaqachon mavjud.",
    err_no_content: "Saqlash uchun kontent yo'q.",
    err_no_changes: "Saqlash uchun hech qanday o'zgarishlar yo'q.",
    err_delete_last_sheet: "Oxirgi varaqni oʻchirib boʻlmadi.",
    err_extract_frames: "Hech qanday ramka chiqarib boʻlmadi.",
    err_indexeddb: "Mahalliy saqlash amalga oshmadi. Sizning brauzeringiz IndexedDB-ni qo'llab-quvvatlamasligi mumkin.",
    msg_upload_success: "Yuklash muvaffaqiyatli: {0}",
    msg_upload_failed: "Yuklab bo‘lmadi: {0}",
    msg_save_success: "Saqlash muvaffaqiyatli.",
    msg_saving: "Saqlanmoqda...",
    msg_multi_save_result: "Saqlangan {0} ta obyekt. {1} ta xato.",
    menu_title: "Menyu",
    menu_save: "Saqlash",
    menu_save_all: "Hammasini saqlash",
    menu_support: "Qo‘llab-quvvatlash xizmatiga murojaat qiling",
    label_local_storage: "Mahalliy saqlash",
    label_sign_in: "Tizimga kirish",
    modal_export_title: "Sprite-ni eksport qiling",
    label_filename: "Fayl nomi",
    label_format: "Format",
    action_export_confirm: "Eksport",
};

export default translations;
